import { Injectable } from '@angular/core';
import { FrequentlyAskedQuestionData, FrequentlyAskedQuestionItemData } from '../components/frequently-asked-question/frequently-asked-question.component';

@Injectable({
  providedIn: 'root'
})
export class FaqsService {
  private callbacks = new Map<string, {toggle: () => void, isVisible: () => boolean}>();

  constructor() { }

  getMarkedUpFaqs(modules: any[]) {
    return modules
      .filter(module => this.isFAQsModule(module))
      .map(module => {
        const faqsModule: FrequentlyAskedQuestionData = module.data;
        const mainEntity = faqsModule.items.map(item => this.getMainEntity(item));
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity
        };
    });
  }

  private getMainEntity(faqItem: FrequentlyAskedQuestionItemData) {
    return {
      '@type': 'Question',
      name: faqItem.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faqItem.answer
      }
    };
  }

  private isFAQsModule(module: any) {
    return FaqsService.getFaqsModules().includes(module.id);
  }

  static getFaqsModules(): Array<string> {
    return [
      'HotelsByCityFAQsModule',
      'HotelsByPoiFAQsModule',
      'HotelsByZoneFAQsModule',
      'HotelsByAmenityFAQsModule',
      'HotelsByTypeFAQsModule',
      'HotelsByTypeHouseFAQsModule',
      'HotelsByTypeChaletFAQsModule',
      'HotelsByTypeApartmentFAQsModule',
      'HotelsByTypeApartmentAndHouseFAQsModule',
      'HotelsByTypeGuestHouseFAQsModule',
      'HotelsByStarFAQsModule',
      'HotelsByChainFAQsModule',
      'VacationRentalsFAQsModule',
      'PackagesByCityFAQsModule',
      'PaymentsPromosFAQsModule',
      'FaqsModule'
    ];
  }

  closeAllFaqs(): void {
    this.callbacks.forEach(faq => {
      if (faq.isVisible()) faq.toggle();
    })
  }

  openFaqById(faqId: string, shouldCloseAllFaqs?: boolean): void {
    if (shouldCloseAllFaqs) {
      this.closeAllFaqs();
    }
    this.callbacks.get(faqId)?.toggle();
  }

  registerFaqCallbacks(faqId: string, toggle: () => void, isVisible: () => boolean): void {
    this.callbacks.set(faqId, {toggle, isVisible});
  }

  unregisterFaqCallbacks(faqId: string): void {
    this.callbacks.delete(faqId);
  }
}
